var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[[_c('h4',{staticClass:"not-margin",style:({marginTop: '10px'})},[_c('img',{staticClass:"img-profile",attrs:{"src":_vm.profile}})])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }